<div id="ujx_toast">
    <div class="{{textPosition}} toast_con toast_{{textType}}">
        <div id="img">
            <i [ngClass]="
            (textType == 'success') ? 'far fa-check-circle' :
                (textType == 'info') ? 'fa fa-info-circle' : 
                    (textType == 'alert' || textType == 'error') ? 'far fa-bell' :
                        (textType == 'warn') ? 'fas fa-exclamation-circle' :
                         'fas fa-exclamation-triangle'"></i></div>
        <div id="desc" class="text_box1">
            <h3 class="heading_toast">{{textType}}</h3>
            <div> {{textMessage}}</div>
        </div>
    </div>
</div>


